import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['progress'];
  static values = {
    sessionId: String,
  };

  connect() {
    this.progressValue = 0;
    this.startTime = Date.now();
    this.progressInterval = null;
    this.statusInterval = null;
    this.generationStarted = false;

    // Start both progress animation and status checking
    this.startProgressAnimation();
    this.startStatusCheck();
  }

  disconnect() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }

    if (this.statusInterval) {
      clearInterval(this.statusInterval);
      this.statusInterval = null;
    }
  }

  startProgressAnimation() {
    // Animation for up to 20 seconds or until generation completes
    this.progressInterval = setInterval(() => {
      const elapsed = Date.now() - this.startTime;
      const maxDuration = 20000; // 20 seconds max
      const progress = Math.min((elapsed / maxDuration) * 100, 100);

      this.progressValue = progress;

      if (this.hasProgressTarget) {
        this.progressTarget.style.width = `${this.progressValue}%`;
      }

      if (this.progressValue >= 100) {
        this.completeProgress();
      }
    }, 200);
  }

  startStatusCheck() {
    this.statusInterval = setInterval(() => {
      this.checkGenerationStatus();
    }, 500); // Check every 500ms
  }

  async checkGenerationStatus() {
    try {
      const response = await fetch(
        `/questions/ai/generation_status?session_id=${this.sessionIdValue}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
        },
      );

      if (!response.ok) {
        console.warn('⚠️ Failed to check generation status:', response.status);
        return;
      }

      const data = await response.json();

      if (data.completed) {
        this.completeProgress();
      }
    } catch (error) {
      console.error('🌐 Network error checking status:', error);
    }
  }

  completeProgress() {
    // Clear both intervals
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }

    if (this.statusInterval) {
      clearInterval(this.statusInterval);
      this.statusInterval = null;
    }

    // Ensure progress is 100%
    this.progressValue = 100;
    if (this.hasProgressTarget) {
      this.progressTarget.style.width = '100%';
    }

    // Show continue button
    const continueButton = document.getElementById('continue-button');
    if (continueButton) {
      continueButton.classList.remove('tw-hidden');
    }
  }
}
